var colours = function colours(theme, key, value) {
  var defkey = typeof key === 'undefined' ? 'primary' : key;

  if (defkey === 'transparent') {
    return theme.colours.transparent;
  }

  return theme.colours[defkey][value];
};

export var setColour = function setColour(props, overrideField, themeColour) {
  var overideColor = props.override && props.override[overrideField];
  return overideColor || colours(props.theme, props.colour, themeColour);
};
export default colours;